import React from "react";
import PropTypes from "prop-types";

const Divider = ({ field }) =>
  field.color ? (
    <div
      className={`divider-web-sdk ${field.params.split("|").join()}`}
      style={{ borderColor: field.color?.replace("0x", "#") }}
    />
  ) : (
    <hr
      className={`divider ${field.name} ${
        field.params ? field.params.split("|").join(" ") : ""
      }`}
      aria-hidden='true'
    />
  );

Divider.propTypes = {
  field: PropTypes.shape({
    color: PropTypes.string,
    name: PropTypes.string.isRequired,
    params: PropTypes.string.isRequired
  })
};

export default Divider;
